import { useEffect } from 'react'

export const HIDE_BOTTOM_MENU_CLASS = 'bottom-menu-hidden'

/**
 * Hides the mobile bottom navigation while a full-screen page view (e.g. the
 * filter screen on the bookings/quotes/invoices lists) is open.
 *
 * The bottom menu is rendered by the router layout, outside of the page, so the
 * page cannot hide it directly. Same approach as the `keyboard-open` class.
 */
export const useHideBottomMenu = hide => {
  useEffect(() => {
    if (!hide) {
      return undefined
    }

    document.body.classList.add(HIDE_BOTTOM_MENU_CLASS)

    return () => {
      document.body.classList.remove(HIDE_BOTTOM_MENU_CLASS)
    }
  }, [hide])
}
